import * as types from 'actions/actionTypes';

const initialState = {
  defaultInventoryLocation: null,
  isLoading: false,
  isSelectAllChecked: false,
  locations: [],
  searchString: '',
  selectedCount: 0,
  selectedLocations: [],
};

export default function inventoryLocations(state = initialState, action) {
  switch (action.type) {
    case types.inventoryLocationActionTypes.GET_INVENTORY_LOCATIONS_SUCCESS:
      return {
        ...state,
        isSelectAllChecked: false,
        selectedCount: 0,
        locations: action.locations,
        searchString: action.searchString,
      };

    case types.inventoryLocationActionTypes
      .GET_DEFAULT_INVENTORY_LOCATION_SUCCESS:
      return {
        ...state,
        defaultInventoryLocation: action.defaultInventoryLocation,
      };

    case types.inventoryLocationActionTypes.INVENTORY_LOCATIONS_LOADING:
      return {...state, isLoading: true};

    case types.inventoryLocationActionTypes
      .INVENTORY_LOCATIONS_LOADING_COMPLETE:
      return {...state, isLoading: false};

    case types.inventoryLocationActionTypes
      .INVENTORY_LOCATION_BATCH_SELECT_INDIVIDUAL_UPDATED: {
      const {locations} = state;
      const updatedLocations = locations.map(i => {
        return {
          ...i,
          isChecked:
            i.inventoryLocationId === action.location.inventoryLocationId
              ? !i.isChecked
              : i.isChecked,
        };
      });

      return {
        ...state,
        isSelectAllChecked: false,
        selectedCount: updatedLocations.filter(loc => !!loc.isChecked).length,
        locations: updatedLocations,
      };
    }

    case types.inventoryLocationActionTypes
      .INVENTORY_LOCATION_BATCH_SELECT_ALL_UPDATED: {
      const {locations} = state;
      const updatedLocations = locations.map((loc, i) => ({
        ...loc,
        isChecked:
          !loc.isDefault &&
          i >= action.startIdx &&
          action.endIdx &&
          i < action.endIdx
            ? action.isChecked
            : false,
      }));

      return {
        ...state,
        isSelectAllChecked: action.isChecked,
        selectedCount: action.isChecked
          ? updatedLocations.filter(x => x.isChecked).length
          : 0,
        locations: updatedLocations,
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/inventoryLocationsReducer.js